import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-header',
  templateUrl: './topheader.component.html',
  styleUrls: ['./topheader.component.scss']
})
export class TopHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
